// extracted by mini-css-extract-plugin
export default {"pageTitle":"ymHfEtqoXS31x3cNCPrM"};